import { Checkbox as CarbonCheckbox } from "@carbon/react";

export const View = (props) => {
  return (
    <div className="input-container">
      <CarbonCheckbox
        // helperText="Optional helper text"
        id={props.id}
        invalidText={props.invalidText}
        labelText={props.label}
        // placeholder={props.placeholder}
        placeholder="Placeholder text"
        {...props}
        className={`${props.className} switchapp-themed`}
      />
    </div>
  );
};
